import { formatDate } from 'helpers';
import fp from 'lodash/fp';

export const getName = fp.get('name');

export const getIcon = fp.get('icon');

export const getCreated = fp.compose(formatDate, fp.get('created'));
